import { MutualFundTableBodyProps, TableBodyData } from "../../investorOverview/types";
import { Box, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import { SxProps, Theme } from "@mui/system";
import { toINR } from "../../../utils/utilityFunctions";
import { NonMfTransactionDetailsData, TransactionDetailsData } from "../../../redux-store/types/products";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";
import { BseClientActivationStatusMaster, BseClientActivationStatusMasterShort } from "../../../utils/constant";
import dayjs from "../../../utils/date";

export default function MutualFundTranscationBody(
    {
        tableBodyData,
        tableBodyRowCustomStyles = {},
    }: {
        tableBodyData: TransactionDetailsData[];
        tableBodyRowCustomStyles: SxProps<Theme>,
    }
): JSX.Element {
    const { palette } = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData) => (
                <TableRow
                    key={obj?.scheme}
                    sx={{
                        '& td': {
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${palette.text.secondary}B2`,
                        },
                        ...tableBodyRowCustomStyles
                    }}
                >
                    <TableCell
                        align="left"
                        width={400}
                    >
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {obj?.investorName}
                        </Typography>
                    </TableCell>
                    <TableCell
                        align="center"
                    >
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {obj?.portfolioId}
                        </Typography>
                    </TableCell>
                    <TableCell
                        align="center"
                        width={750}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'row' }}>

                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    lineHeight: "20px",
                                    letterSpacing: '0.02px'
                                })}
                            >
                                {obj?.schemeName}
                            </Typography>
                        </Box>
                    </TableCell>
                    <TableCell
                        align="center"
                    >
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {obj?.schemeCategory}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {toINR({ value: obj?.amount, locale, currencyCode })}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {!Number.isNaN(Number(obj?.units)) ?
                                Math.round(obj.units * 100) / 100 : '0'}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >

                            {obj?.type}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >

                            {BseClientActivationStatusMasterShort[obj?.bseClientActivationStatus ?? ''] ?? '-'}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                             {dayjs(obj?.date).format('DD/MM/YYYY')}
                        </Typography>
                    </TableCell>
                </TableRow>
            ))}
        </>
    )
}